__turbopack_context__.v({
  "content": "d6s_WG_content",
  "error": "d6s_WG_error",
  "form": "d6s_WG_form",
  "header": "d6s_WG_header",
  "icon": "d6s_WG_icon",
  "inputs": "d6s_WG_inputs",
  "link": "d6s_WG_link",
  "links": "d6s_WG_links",
  "loginForm": "d6s_WG_loginForm",
  "logo": "d6s_WG_logo",
  "note": "d6s_WG_note",
  "title": "d6s_WG_title",
});
